export default __webpack_public_path__ + "static/media/logo_white.7b589756.png";